import { ReactNode } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import {
  AtsHiringStageNames,
  UNASSIGNED_STAGE,
  getProperties,
} from 'modules/ats/lib/utils/hiringStages'

interface Props {
  stageName: AtsHiringStageNames
  stageLabel: string
  children?: ReactNode
}

export const HiringStageBox = ({ stageName, stageLabel, children }: Props) => {
  const properties = getProperties(stageName)

  return (
    <Box
      borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
      padding="s16"
      gap="s16"
      background={stageName === UNASSIGNED_STAGE ? 'radicalRed050' : 'grey100'}
      border={{
        all: { color: 'grey400', style: 'solid', width: 's1' },
        top: { color: properties.color, style: 'solid', width: 's4' },
      }}
    >
      <Box flexDirection="row" width="full" alignItems="center" gap="s8">
        <Icon.Medium icon={properties.icon} color="grey800" />
        <Text.Normal weight="medium" color="grey800">
          {stageLabel}
        </Text.Normal>
      </Box>

      {children}
    </Box>
  )
}
